import React, { useContext, useEffect, useState, useRef } from "react";
import AuthContext from "../../context/userAuth.context";
import Lottie from "react-lottie";
import load from "../../assets/Loader/AssetLoader.json";
import { useHistory } from "react-router";
import axios from "axios";
import CharacterContext from "../../context/CharacterContext";
import Swal from "sweetalert2";
import DriveFileMoveIcon from "@mui/icons-material/DriveFileMove";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import ButtonGroup from "@mui/material/ButtonGroup";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Grow from "@mui/material/Grow";
import Paper from "@mui/material/Paper";
import Popper from "@mui/material/Popper";
import MenuItem from "@mui/material/MenuItem";
import MenuList from "@mui/material/MenuList";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import IconButton from "@mui/material/IconButton";
import CardMedia from "@mui/material/CardMedia";
import CardActions from "@mui/material/CardActions";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Box from "@mui/material/Box";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import Menu from "@mui/material/Menu";
import StarsIcon from "@mui/icons-material/Stars";
import ListItemIcon from "@mui/material/ListItemIcon";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import Tooltip from "@mui/material/Tooltip";
import PersonAdd from "@mui/icons-material/PersonAdd";
import Settings from "@mui/icons-material/Settings";
import Logout from "@mui/icons-material/Logout";
import Stack from "@mui/material/Stack";
import ShareIcon from "@mui/icons-material/Share";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import CategoryModal from "./Categorymodal";
import RenameModal from "./RenameModal";
import { AIGeneratingCards } from "../../AIStudio/AIDashboardBits";

const options = [
  "Create a merge commit",
  "Squash and merge",
  "Rebase and merge",
];
export const SaveProject = () => {
  const [CategorModalOpen, setCategorModalOpen] = React.useState(false);
  const OpenCategoryModal = () => {
    setCategorModalOpen(true);
  };
  const [showRenameModal, setshowRenameModal] = useState(false);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [currentValue, setcurrentValue] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event, value) => {
    setAnchorEl(event.currentTarget);
    setcurrentValue(value);
  };
  const handleClose = () => {
    setAnchorEl(null);
    //setcurrentValue(null);
  };
  let history = useHistory();

  const {
    AllProject,
    setDivName,
    setAllProject,
    authenticationData,
    Role,
    Access,
    getLink
  } = useContext(AuthContext);
  const [showpop, setshowpop] = useState(false);
  const [projects, setprojects] = useState([]);
  const clicked = (type) => {
    let authData = JSON.parse(
      localStorage.getItem("animation_studio_2.0_access_token")
    );
    if (type == "Duplicate") {
      Swal.fire({
        title: "Are you sure you want to duplicate this project?",
        text: "This will create a copy of your project",
        icon: "warning",
        buttons: [true, "Duplicate"],
        cancelButtonColor: "#d33",
        // confirmButtonText: "Yes, Clear it!",
        dangerMode: true,
        backdrop: null,
      }).then((willDelete) => {
        if (willDelete) {
          fetch(
            authenticationData.ApiBaseURL +
              "/api/Project/DupliacateProject?id=" +
              currentValue.id,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*",
                Authorization: "Bearer " + authData.access_token,
              },
            }
          )
            .then((response) => response.json())
            .then((data) => {
              if (data.status) {
                setAllProject(AllProject.concat(data.result));
                Swal.fire(
                  "Duplicated Successfully",
                  "Your project has been duplicated and added at the end of the list.",
                  "success"
                );
                //setShow(false);
              }
            })
            .catch((error) => {});
        }
      });
    } else if (type == "Delete") {
      Swal.fire({
        title: "Are you sure you want to delete this project?",
        text: "You won't be able to revert this!",
        icon: "warning",
        buttons: [true, "Delete"],
        cancelButtonColor: "#d33",
        // confirmButtonText: "Yes, Clear it!",
        dangerMode: true,
        backdrop: null,
      }).then((willDelete) => {
        if (willDelete) {
          fetch(
            authenticationData.ApiBaseURL +
              "/api/Project/DeleteProject?id=" +
              currentValue.id,
            {
              method: "DELETE",
              headers: {
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*",
                Authorization: "Bearer " + authData.access_token,
              },
            }
          )
            .then((response) => response.json())
            .then((res) => {
              if (res) {
                filt(currentValue.id);
              }
            })
            .catch((error) => {});
        }
      });
    } else if (type == "Rename") {
      setshowRenameModal(true);
    } else if (type == "IsPremium") {
      let formdata = new FormData();
      formdata.append("ProjectId", currentValue.id);
      axios
        .post(
          authenticationData.ApiBaseURL + "/api/Template/MarkPremium",
          formdata,
          {
            headers: {
              "Content-Type": `multipart/form-data`,
              "Access-Control-Allow-Origin": "*",
              Authorization: "Bearer " + authData.access_token,
            },
          }
        )
        .then((res) => {
          if (res.data.status == true) {
            alert("Updated Successfully....");
          }
        });
    }
  };
  const handlechange = (e) => {
    if (e.target.value != null && e.target.value != "") {
      var array = Array.from(AllProject);
      let changeArray = array.filter(function (value, index, arr) {
        let PName = value.projectName.toLowerCase();
        let tName = e.target.value.toLowerCase();
        if (PName.includes(tName)) {
          return value;
        }
      });
      setprojects(Array.from(changeArray));
    } else {
      setprojects(AllProject);
    }
  };

  const filt = (id) => {
    let array = Array.from(AllProject);

    let changeArray = array.filter(function (value, index, arr) {
      if (value.id != id) {
        return value;
      }
    });
    setAllProject(changeArray);
  };

  const ChooseProject = (params) => {
    localStorage.removeItem("CurrentChooseProject");
    sessionStorage.removeItem("myProjectData");
    if (params.projectData != null) params.projectData = null;
    sessionStorage.setItem("myProjectData", JSON.stringify(params));
    history.push("/editor");

    // let authData = JSON.parse(localStorage.getItem("animation_studio_2.0_access_token"));
    // axios.get(authenticationData.ApiBaseURL + "/api/Project/GetMyProject?id=" + params.id, {
    //     headers: {
    //         "Content-Type": `multipart/form-data`,
    //         "Access-Control-Allow-Origin": "*",
    //         Authorization: "Bearer " + authData.access_token,
    //     },
    // }).then(response => {
    //     if (response.data != null && response.data.result[0]) {

    //         let projData = JSON.parse(response.data.result[0]);
    //         for (let i = 0; i < projData.length; i++) {
    //             for (let j = 0; j < projData[i].LayerData.length; j++) {
    //                 if (projData[i].LayerData[j].type == "text" && !projData[i].LayerData[j].googleFontSetting) {
    //                     projData[i].LayerData[j].googleFontSetting = {
    //                         "fontName": "Roboto",
    //                         "fontFamily": "'Roboto', sans-serif",
    //                         "googleFontUrl": "https://fonts.googleapis.com/css2?family=Roboto:wght@100&display=swap"
    //                     }
    //                 }
    //             }
    //         }
    //         params.projectData = JSON.stringify(projData); //response.data.result[0];
    //         localStorage.removeItem('CurrentChooseProject')
    //         localStorage.setItem('CurrentChooseProject', JSON.stringify(params));
    //         //window.open('http://localhost:3000/editor', '_blank');
    //         history.push('/editor')
    //     }
    // }).catch(error => {

    // });
  };

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: require("../../assets/Loader/NoDataAnimation.json"),
  };

  const [Loader, setLoader] = useState(true);

  useEffect(() => {
    setLoader(true);
    if (AllProject.length == 0) {
      let authData = JSON.parse(
        localStorage.getItem("animation_studio_2.0_access_token")
      );
      axios
        .get(authenticationData.ApiBaseURL + "/api/Project/GetProject", {
          headers: {
            "Content-Type": `multipart/form-data`,
            "Access-Control-Allow-Origin": "*",
            Authorization: "Bearer " + authData.access_token,
          },
        })
        .then((response) => {
          if (response.data != null) {
            if (response.data.result) {
              setAllProject(response.data.result);
            } else {
              setAllProject([]);
            }
            setLoader(false);
          }
        })
        .catch((error) => {});
    }
  }, []);

  useEffect(() => {
    if (AllProject.length != 0) {
      setLoader(false);
      setprojects(AllProject);
    } else {
      setprojects([]);
    }
  }, [AllProject]);

  const ConvertDate = (tick) => {
    if (tick) {
      var ticksToMicrotime = parseInt(tick) / 10000;
      var epochMicrotimeDiff = Math.abs(new Date(0, 0, 1).setFullYear(1));
      var tickDate = new Date(ticksToMicrotime - epochMicrotimeDiff);
      return tickDate.toDateString();
    } else {
      return "";
    }

    // setData(tickDate.toDateString());
  };

  return (
    <>
      <div className="mt-3" style={{ position: "relative" }}>
        <span className="material-icons SaveProjectSearch">search</span>
        <input
          className="SaveProjectInput"
          type="text"
          autoComplete="off"
          onKeyDown={handlechange}
          placeholder="Search Projects"
        />
      </div>

      <div className="mt-5 mb-5">
        {Loader && (
          <>
            <div style={{ width: "100%" }}>
              <Lottie
                options={{ loop: true, autoplay: true, animationData: load }}
                height={300}
                width={300}
                isStopped={false}
                isPaused={false}
                renderer="canvas"
              />
            </div>
          </>
        )}
        {!Loader && (
          <>
            <Stack
              spacing={{ xs: 4, sm: 4 }}
              direction="row"
              useFlexGap
              flexWrap="wrap"
            >
              <AIGeneratingCards />
              {projects.length !== 0 &&
                projects.map((value, index) => {
                  return (
                    <Card key={index} sx={{ maxWidth: 345 }}>
                      <CardActions
                        className="mediaCardCustom"
                        onClick={(event) => ChooseProject(value)}
                      >
                        <CardMedia
                          component="img"
                          height="194"
                          image={
                            value.previewImagePath != null &&
                            value.previewImagePath != ""
                              ? authenticationData.ApiBaseURL +
                                "/" +
                                value.previewImagePath
                              : "images/DefaultProject.png"
                          }
                          alt="Project Image"
                        />
                      </CardActions>

                      <Stack
                        p={2}
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                        spacing={2}
                      >
                        <Stack>
                          <div>{value.projectName}</div>
                          <div style={{ fontSize: "12px" }}>
                            {ConvertDate(value.dateModified)}
                          </div>
                        </Stack>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            textAlign: "center",
                          }}
                        >
                          <Tooltip title="More options">
                            <IconButton
                              onClick={(event) => handleClick(event, value)}
                              size="small"
                              sx={{ ml: 2 }}
                              aria-controls={open ? "account-menu" : undefined}
                              aria-haspopup="true"
                              aria-expanded={open ? "true" : undefined}
                            >
                              <MoreVertIcon />
                            </IconButton>
                          </Tooltip>
                        </Box>
                      </Stack>
                    </Card>
                  );
                })}

              <Menu
                anchorEl={anchorEl}
                id="account-menu"
                open={open}
                onClose={handleClose}
                onClick={handleClose}
                PaperProps={{
                  elevation: 0,
                  sx: {
                    overflow: "visible",
                    filter: "drop-shadow(0px 2px 2px rgba(0,0,0,0.1))",
                    mt: 1.5,
                    "& .MuiAvatar-root": {
                      width: 32,
                      height: 32,
                      ml: -0.5,
                      mr: 1,
                    },
                    "&:before": {
                      content: '""',
                      display: "block",
                      position: "absolute",
                      top: 0,
                      right: 14,
                      width: 10,
                      height: 10,
                      bgcolor: "background.paper",
                      transform: "translateY(-50%) rotate(45deg)",
                      zIndex: 0,
                    },
                  },
                }}
                transformOrigin={{
                  horizontal: "right",
                  vertical: "top",
                }}
                anchorOrigin={{
                  horizontal: "right",
                  vertical: "bottom",
                }}
              >
                <MenuItem
                  onClick={() => {
                    if (Access == "FE") {
                      Swal.fire({
                        title: "Upgrade Required",
                        html:
                    `You have not purchased this upgrade yet. Please <a href=${getLink()} target='_blank'>upgrade</a> to unlock all features.`,
                        icon: "info",
                        cancelButtonColor: "#d33",
                        backdrop: null,
                      });
                      return;
                    }
                    clicked("Duplicate");
                  }}
                >
                  <ListItemIcon>
                    <ContentCopyIcon fontSize="small" />
                  </ListItemIcon>
                  Duplicate
                  {Access == "FE" && (
                    <img
                      style={{
                        width: "20px",
                        height: "20px",
                        marginLeft: "3rem",
                      }}
                      src="../AppIcons/IconsAll/ProIcon.svg"
                      alt=""
                    />
                  )}
                </MenuItem>
                <MenuItem onClick={() => clicked("Rename")}>
                  <ListItemIcon>
                    <DriveFileRenameOutlineIcon fontSize="small" />
                  </ListItemIcon>
                  Rename
                </MenuItem>
                <Divider />

                <MenuItem onClick={() => clicked("Delete")}>
                  <ListItemIcon>
                    <DeleteOutlineIcon fontSize="small" />
                  </ListItemIcon>
                  Delete
                </MenuItem>
                <Divider></Divider>
                {Access === "US2" && (
                  <MenuItem
                    onClick={() => {
                      setCategorModalOpen(true);
                      //setshowpop(true);
                      //setShow(false);
                    }}
                  >
                    <ListItemIcon>
                      <StarsIcon fontSize="small" />
                    </ListItemIcon>
                    Set Agency
                  </MenuItem>
                )}

                {Role == "admin" && (
                  <>
                    <MenuItem onClick={() => clicked("IsPremium")}>
                      <ListItemIcon>
                        <StarBorderIcon fontSize="small" />
                      </ListItemIcon>
                      Set Premium
                    </MenuItem>
                    <MenuItem
                      onClick={() => {
                        // setshowpop(true);
                        // setShow(false);
                        setCategorModalOpen(true);
                      }}
                    >
                      <ListItemIcon>
                        <LocalOfferIcon fontSize="small" />
                      </ListItemIcon>
                      Assign Category
                    </MenuItem>
                  </>
                )}
              </Menu>
              {
                <CategoryModal
                  setCategorModalOpen={setCategorModalOpen}
                  CategorModalOpen={CategorModalOpen}
                  value={currentValue}
                ></CategoryModal>
              }
              {
                <RenameModal
                  showRenameModal={showRenameModal}
                  setshowRenameModal={setshowRenameModal}
                  value={currentValue}
                  setAllProject={setAllProject}
                  AllProject={AllProject}
                  authenticationData={authenticationData}
                ></RenameModal>
              }

              {/* // <Catpop value={currentValue} setshowpop={setshowpop} />
               */}
            </Stack>

            {projects.length === 0 && (
              <>
                <div style={{ width: "100%" }}>
                  <Lottie
                    options={defaultOptions}
                    height={300}
                    width={300}
                    isStopped={false}
                    isPaused={false}
                    renderer="canvas"
                  />
                  <div
                    style={{
                      textAlign: "center",
                      fontWeight: "bold",
                      fontSize: "x-large",
                    }}
                  >
                    No Project Found
                  </div>
                  <div
                    className="CTAButton"
                    onClick={() => setDivName("Create")}
                    style={{ width: "163px", margin: "40px auto" }}
                  >
                    Add Project
                  </div>
                </div>
              </>
            )}
          </>
        )}
      </div>
    </>
  );
};
export default SaveProject;

// const PopUp = ({ value }) => {
//   const { authenticationData, setAllProject, AllProject, Role, Access } =
//     useContext(AuthContext);
//   const [Show, setShow] = useState(false);
//   const popref = useRef(null);

//   useEffect(() => {
//     if (Show) {
//       popref.current.focus();
//     }
//   }, [Show]);

//   let authData = JSON.parse(
//     localStorage.getItem("animation_studio_2.0_access_token")
//   );

//   const filt = (id) => {
//     let array = Array.from(AllProject);

//     let changeArray = array.filter(function (value, index, arr) {
//       if (value.id != id) {
//         return value;
//       }
//     });
//     setAllProject(changeArray);
//   };

//   const [NameChange, setNameChange] = useState(true);

//   const Textblur = () => {
//     fetch(
//       authenticationData.ApiBaseURL +
//         `/api/Project/RenameProject?id=${value.id}&newName=${Name}`,
//       {
//         method: "PUT",
//         headers: {
//           "Content-Type": "application/json",
//           "Access-Control-Allow-Origin": "*",
//           Authorization: "Bearer " + authData.access_token,
//         },
//       }
//     )
//       .then((response) => response.json())
//       .then((res) => {
//         if (res) {
//           let array = Array.from(AllProject);
//           for (let i = 0; i < array.length; i++) {
//             if (array[i].id == value.id) {
//               array[i].projectName = Name;
//             }
//           }
//           setAllProject(array);
//           setNameChange(true);
//         }
//       })
//       .catch((error) => {
//         setNameChange(true);
//       });
//   };

//   const [Name, setName] = useState(value.projectName);

//   const ChangedName = (params) => {
//     if (params.key === "Enter") {
//       Textblur();
//     }
//   };

//   const [showpop, setshowpop] = useState(false);

//   const [open, setOpen] = React.useState(false);
//   const anchorRef = React.useRef(null);
//   const [selectedIndex, setSelectedIndex] = React.useState(1);

//   const handleClick = () => {
//     console.info(`You clicked ${options[selectedIndex]}`);
//   };

//   const handleMenuItemClick = (event, index) => {
//     setSelectedIndex(index);
//     setOpen(false);
//   };

//   const handleToggle = () => {
//     setOpen((prevOpen) => !prevOpen);
//   };

//   const handleClose = (event) => {
//     if (anchorRef.current && anchorRef.current.contains(event.target)) {
//       return;
//     }

//     setOpen(false);
//   };
//   return (
//     <>
//       <span className="contentInsider">
//         <div
//           className="contentType typography-subheading-s caption___14hDw"
//           style={{ position: "relative", height: "40px" }}
//         >
//           <div className="ProjectDetails">
//             {NameChange === true && (
//               <div className="title___3aJ-x" style={{ margin: "auto 0" }}>
//                 {value.projectName}
//               </div>
//             )}
//             {NameChange === false && (
//               <input
//                 type="text"
//                 style={{ margin: "auto 0" }}
//                 value={Name}
//                 onKeyDown={(event) => ChangedName(event)}
//                 onBlur={(event) => Textblur(event)}
//                 onChange={(e) => setName(e.target.value)}
//                 autoFocus
//               />
//             )}
//             <ProjectDate tick={value.dateModified} />
//             {/* <span className="material-icons-outlined" onClick={() => setNameChange(false)}
//                             style={{ fontSize: '20px', marginLeft: '5px', cursor: 'pointer' }}>
//                             mode_edit
//                         </span> */}
//           </div>
//           {/* <div className="subTitle___2DmoO">00:26</div> */}

//           {/* <span
//             className="material-icons"
//             onClick={() => setShow(!Show)}
//             style={{
//               position: "absolute",
//               right: "9px",
//               top: "3px",
//               cursor: "pointer",
//             }}
//           >
//             more_vert
//           </span> */}
//         </div>

//         {Show && (
//           <div
//             className="templateOptionsDrop"
//             style={{ animation: "fadeIn 0.5s" }}
//             ref={popref}
//             onMouseLeave={() => setShow(false)}
//           >
//             <div
//               x-placement="top-start"
//               aria-labelledby="dropdown-basic"
//               data-popper-placement="top-start"
//               className="TemplatePostionDropUp shadow-sm border-0 dropdown-menu show"
//               style={{
//                 position: "absolute",
//                 inset: "auto auto 0px 0px",
//                 margin: "0px",
//                 transform: "translate(0px, -36px)",
//               }}
//             >
//               <div
//                 className="dropUpperDiv py-2 px-2"
//                 onClick={() => {
//                   if (Access == "FE") {
//                     Swal.fire({
//                       title: "Upgrade Required",
//                       text: "You have not purchased this upgrade yet. Please upgrade to unlock all features",
//                       icon: "info",
//                       cancelButtonColor: "#d33",
//                       backdrop: null,
//                     });
//                     return;
//                   }
//                   clicked("Duplicate");
//                 }}
//               >
//                 <span className="material-icons DropDownIcon noHover">
//                   content_copy
//                 </span>
//                 <span className="noHover dropdown-item">
//                   <span className="ml-4">
//                     Duplicate{" "}
//                     {Access == "FE" && (
//                       <img
//                         style={{
//                           width: "40px",
//                           height: "40px",
//                         }}
//                         src="../AppIcons/IconsAll/ProIcon.svg"
//                         alt=""
//                       />
//                     )}
//                   </span>
//                 </span>
//               </div>

//               <div
//                 className="dropUpperDiv py-2 px-2"
//                 onClick={() => clicked("Delete")}
//               >
//                 <span className="material-icons DropDownIcon noHover">
//                   delete_outline{" "}
//                 </span>
//                 <span className="noHover dropdown-item">
//                   <span className="ml-4">Delete</span>
//                 </span>
//               </div>

//               <div className="dropUpperDiv py-2 px-2" style={{ opacity: 0.5 }}>
//                 <span className="material-icons DropDownIcon noHover">
//                   share{" "}
//                 </span>
//                 <span className="noHover dropdown-item">
//                   <span className="ml-4">Share a link</span>
//                 </span>
//               </div>

//               <div
//                 className="dropUpperDiv py-2 px-2"
//                 onClick={() => clicked("Rename")}
//               >
//                 <span className="material-icons DropDownIcon noHover">
//                   published_with_changes{" "}
//                 </span>
//                 <span className="noHover dropdown-item">
//                   <span className="ml-4">Rename</span>
//                 </span>
//               </div>

//               <div className="dropUpperDiv py-2 px-2" style={{ opacity: 0.5 }}>
//                 <span className="material-icons DropDownIcon noHover">
//                   file_upload{" "}
//                 </span>
//                 <span className="noHover dropdown-item">
//                   <span className="ml-4">Export</span>
//                 </span>
//               </div>

//               {Role == "admin" && (
//                 <div
//                   className="dropUpperDiv py-2 px-2"
//                   onClick={() => {
//                     setshowpop(true);
//                     setShow(false);
//                   }}
//                 >
//                   <span className="material-icons DropDownIcon noHover">
//                     file_upload{" "}
//                   </span>
//                   <span className="noHover dropdown-item">
//                     <span className="ml-4">Assign</span>
//                   </span>
//                 </div>
//               )}

//               {Role == "admin" && (
//                 <div
//                   className="dropUpperDiv py-2 px-2"
//                   onClick={() => clicked("IsPremium")}
//                 >
//                   <span className="material-icons DropDownIcon noHover">
//                     <svg
//                       xmlns="http://www.w3.org/2000/svg"
//                       width="24"
//                       height="24"
//                       viewBox="0 0 24 24"
//                     >
//                       <path
//                         fill="currentColor"
//                         d="M5 16L3 5l5.5 5L12 4l3.5 6L21 5l-2 11H5m14 3c0 .6-.4 1-1 1H6c-.6 0-1-.4-1-1v-1h14v1Z"
//                       />
//                     </svg>{" "}
//                   </span>
//                   <span className="noHover dropdown-item">
//                     <span className="ml-4">IsPremium</span>
//                   </span>
//                 </div>
//               )}

//               {Access === "US2" && (
//                 <div
//                   className="dropUpperDiv py-2 px-2"
//                   onClick={() => {
//                     setshowpop(true);
//                     setShow(false);
//                     //clicked('Agency')
//                   }}
//                 >
//                   <DriveFileMoveIcon></DriveFileMoveIcon>

//                   <span className="ml-4">Set Agency</span>
//                 </div>
//               )}
//             </div>
//           </div>
//         )}

//         {showpop && <Catpop value={value} setshowpop={setshowpop} />}
//       </span>
//     </>
//   );
// };

// const Catpop = ({ value, setshowpop }) => {
//   const { authenticationData, Access } = useContext(AuthContext);

//   const { Categories } = useContext(CharacterContext);

//   const [Selected, setSelected] = useState(
//     value.categoryIds == null ? [] : JSON.parse(value.categoryIds)
//   );

//   const [PreviewVideoURL, setPreviewVideoURL] = useState(null);

//   let authData = JSON.parse(
//     localStorage.getItem("animation_studio_2.0_access_token")
//   );

//   const send = () => {
//     if (Access == "US2") {
//       let formdata = new FormData();
//       formdata.append("id", value.id);
//       formdata.append("categoryIds", JSON.stringify(Selected));
//       formdata.append("videopreivewlink", PreviewVideoURL);
//       axios
//         .post(
//           authenticationData.ApiBaseURL +
//             "/api/Category/AssignAgencyTemplateToCategory",
//           formdata,
//           {
//             headers: {
//               "Content-Type": `multipart/form-data`,
//               "Access-Control-Allow-Origin": "*",
//               Authorization: "Bearer " + authData.access_token,
//             },
//           }
//         )
//         .then((res) => {
//           if (res.status) {
//             Swal.fire(
//               "Excellent",
//               "Template Marked as Agency Template",
//               "success"
//             );
//           }
//         });
//       return;
//     }
//     fetch(
//       authenticationData.ApiBaseURL +
//         `/api/Category/AssignCategory?Id=${
//           value.id
//         }&categoryIds=${JSON.stringify(Selected)}`,
//       {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           "Access-Control-Allow-Origin": "*",
//           Authorization: "Bearer " + authData.access_token,
//         },
//       }
//     )
//       .then((response) => response.json())
//       .then((res) => {
//         if (res.status) {
//           Swal.fire("Excellent", "Category Assigned", "success");
//         }
//       })
//       .catch();
//   };

//   return (
//     <>
//       <div className="templateOptionsDrop" style={{ animation: "fadeIn 0.5s" }}>
//         <div
//           x-placement="top-start"
//           aria-labelledby="dropdown-basic"
//           data-popper-placement="top-start"
//           className=" shadow-sm border-0 dropdown-menu show"
//           style={{
//             position: "absolute",
//             inset: "auto auto 0px 0px",
//             margin: "0px",
//             boxshadow: "0 8px 16px rgb(0 0 0 / 39%)",
//             transform: "translate(-166px, 37px)",
//           }}
//         >
//           <Paper sx={{ width: 320, maxWidth: "100%" }}>
//             <MenuList>
//               <MenuItem>
//                 {Access == "US2" && (
//                   <div>
//                     <TextField
//                       label="Preview Video Link"
//                       onChange={(e) => setPreviewVideoURL(e.target.value)}
//                       variant="outlined"
//                       color="secondary"
//                       sx={{ mb: 3 }}
//                       fullWidth
//                       value={PreviewVideoURL}
//                     />
//                   </div>
//                 )}
//               </MenuItem>
//               {Categories.length != 0 &&
//                 Categories.map((lmc, index) => (
//                   <>
//                     <MenuItem>
//                       <Tick
//                         lmc={lmc}
//                         index={index}
//                         Selected={Selected}
//                         setSelected={setSelected}
//                       />
//                     </MenuItem>
//                   </>
//                 ))}

//               <MenuItem>
//                 <div>
//                   <button onClick={send}>save</button>
//                   <button
//                     style={{ float: "right" }}
//                     onClick={() => {
//                       setshowpop(false);
//                     }}
//                   >
//                     cancel
//                   </button>
//                 </div>
//               </MenuItem>
//             </MenuList>
//           </Paper>
//           {Access == "US2" && (
//             <div>
//               <TextField
//                 label="Preview Video Link"
//                 onChange={(e) => setPreviewVideoURL(e.target.value)}
//                 variant="outlined"
//                 color="secondary"
//                 sx={{ mb: 3 }}
//                 fullWidth
//                 value={PreviewVideoURL}
//               />
//             </div>
//           )}
//           <div
//             style={{
//               height: "306px",
//               width: "300px",
//               overflowY: "scroll",
//               position: "relative",
//             }}
//           >
//             {Categories.length != 0 &&
//               Categories.map((lmc, index) => (
//                 <>
//                   <Tick
//                     lmc={lmc}
//                     index={index}
//                     Selected={Selected}
//                     setSelected={setSelected}
//                   />
//                 </>
//               ))}
//           </div>

//           <div>
//             <button onClick={send}>save</button>
//             <button
//               style={{ float: "right" }}
//               onClick={() => {
//                 setshowpop(false);
//               }}
//             >
//               cancel
//             </button>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// const Tick = ({ lmc, index, Selected, setSelected }) => {
//   const [check, setcheck] = useState(false);

//   const select = (params) => {
//     if (Selected.length != 0) {
//       let found = false;
//       for (let i = 0; i < Selected.length; i++) {
//         if (Selected[i] == params) {
//           found = true;
//         }
//       }
//       if (!found) {
//         const array = Array.from(Selected);
//         array.push(params);
//         setSelected(array);
//       }
//     } else {
//       const array = Array.from(Selected);
//       array.push(params);
//       setSelected(array);
//     }
//   };

//   useEffect(() => {
//     if (Selected.length != 0) {
//       for (let i = 0; i < Selected.length; i++) {
//         if (Selected[i] == lmc.id) {
//           setcheck(true);
//         }
//       }
//     }
//   }, [Selected]);

//   return (
//     <div
//       key={index.toString()}
//       className="dropUpperDiv py-2 px-2"
//       onClick={() => {
//         select(lmc.id);
//         setcheck(!check);
//       }}
//     >
//       {check && (
//         <span className="material-icons DropDownIcon noHover">done </span>
//       )}
//       <span className="noHover dropdown-item">
//         <span className="ml-4">{lmc.name}</span>
//       </span>
//     </div>
//   );
// };

// const ProjectDate = ({ tick }) => {
//   const [Data, setData] = useState(null);

//   useEffect(() => {
//     var ticksToMicrotime = parseInt(tick) / 10000;
//     var epochMicrotimeDiff = Math.abs(new Date(0, 0, 1).setFullYear(1));
//     var tickDate = new Date(ticksToMicrotime - epochMicrotimeDiff);
//     setData(tickDate.toDateString());
//   }, []);

//   return <>{Data != null && { Data }}</>;
// };
